/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isgestellungscontract2Inputs */



/**

* @param {_Field_Isgestellungscontract2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_isgestellungscontract2 = /** @type {((inputs?: _Field_Isgestellungscontract2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isgestellungscontract2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ist Gestellungsvertrag")
});
export { _field_isgestellungscontract2 as "_field_isGestellungsContract" }